export default __webpack_public_path__ + "static/ClarityNuvo-Regular-e1eeea8bb1b723401bf3f0a7aca6355c.woff2";